var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTgBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2061 7.21424C32.6086 7.04486 33.049 6.98644 33.4817 7.04507C33.9144 7.10369 34.3234 7.27722 34.6663 7.54758C35.0092 7.81794 35.2733 8.17526 35.4312 8.58234C35.5891 8.98942 35.635 9.43138 35.5641 9.86222L31.8706 32.2658C31.5124 34.4268 29.1412 35.6661 27.1593 34.5897C25.5015 33.6891 23.0392 32.3016 20.8244 30.8539C19.717 30.1292 16.3248 27.8085 16.7417 26.1572C17.1 24.7453 22.7998 19.4396 26.0568 16.2851C27.3352 15.0458 26.7522 14.3309 25.2426 15.4708C21.4937 18.3012 15.4747 22.6054 13.4846 23.817C11.7291 24.8853 10.8139 25.0677 9.7195 24.8853C7.72293 24.5531 5.8713 24.0385 4.36003 23.4115C2.31787 22.5647 2.41721 19.7571 4.35841 18.9396L32.2061 7.21424Z",
    fill: "#0F242F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTgBlue);
export default __webpack_public_path__ + "static/media/icon_tg_blue.8910402eaf2a0a9cd025a1baef6f39bf.svg";
export { ForwardRef as ReactComponent };